
//import { CoordinateProcessor } from '../../utils/CoordinateProcessor';
import { useMapStore } from "../../store/useMapStore.js";
import { wgsRelativeToCenter } from "../../services/MercatorRelativeToCenter.js";
import { mercatorRelative, wgsRelative } from "../../services/MercatorRelativeToCenter.js";
import { LOD2BuildingEntity } from "./BuildingEntity.js";
import proj4 from "proj4";

export class FlurstuckEntity {
    
    constructor(data = {},crs) {

        
        this.amtlicheFlaeche = data.officialArea + ' m²'|| 0;
        this.gemarkungName = data.cadastralDistrictName || "";
        this.gemarkungSchluessel  = data.cadastralDistrictKey|| "";
        this.baugebiet = data.constructionArea || "";
        this.abstandflaechen = data.setbackAreas || "";
        this.gemeindeSchluessel  = data.municipalityKey || "";
        this.gemeindeName = data.municipalityName || "";
        this.flurnummer = data.parcelNumber || '';
        this.id = data.id || '';
        this.flurstücknummer = data.parcelIdentifier || "";
        this.untergrundklasse = data.subsoilClass || "";
        this.nutzungsart = data.landuse || "";
        this.windlastzone = data.windLoadZone || "";
        this.schneelastzone = data.snowLoadZone || "";
        this.erdbebenzone = data.earthquakeZone || 0;
        this.bmz = data.bmz || "";
        this.grz = data.grz || "";
        this.gfz =  data.gfz || "";
        this.Name = "FlurstuckEntity";
        this.grundstuecksflaeche = data.grundstuecksflaeche.toFixed(4) + ' m²'|| 0;;
        //this.geometry = FlurstuckEntity.wgs84ToWebMercator(data.geometry) || null;
        this.geometry = data.geometry|| null;
        this.center = useMapStore.getState().center;
        //this.utm32center = wgsToUTM32(this.center);
        //console.log(this.center);
        //this.wgscoords = mercatorTowgs(this.geometry.coordinates)
        //this.utm32coords = mercatorToUTM32(this.geometry.coordinates,  this.utm32center)
        if(crs == "EPSG3857")
        {
        
             this.mercatorCoordinates= mercatorRelative(this.geometry.coordinates);
        }
        if(crs == "EPSG25832" || crs == "EPSG25833")
        {
        
            this.mercatorCoordinates= this.geometry.coordinates;
            
        }
        else{
            //console.log(this.geometry.coordinates.flat())
            
            this.mercatorCoordinates = wgsRelative(this.geometry.coordinates, useMapStore.getState().center);
            console.log(this.mercatorCoordinates)
        }
        
        //this.buildings = LOD2BuildingEntity.fromResponse(data.buildings)
       //console.log("Logging buildings from Flurstueckentity", this.buildings)
    }

    
    static fromResponse(response, crs) {
    if (response && response.data && response.data.parcelByBounds.parcels) {
        return response.data.parcelByBounds.parcels.map(
        entityData => new FlurstuckEntity(entityData, crs)
        );
    }
    return [];
    }   
}

 function mercatorTowgs(coords) {
   
    const WEB_MERCATOR = "EPSG:3857";
    const WGS84 = "EPSG:4326";

  if (!Array.isArray(coords)) {
    throw new Error("Input must be an array of coordinates.");
  }
 const mercatorArray = coords.map(coordArray => {
             
            return  coordArray.map(([x,y]) => {
                const [lon, lat]   =  proj4(WEB_MERCATOR, WGS84, [x, y]);
              

                    return [lon, lat]; 
             });
             

         });
         return mercatorArray;
}

function wgsToUTM32(mapcenter) {
    
    const WGS84 = "EPSG:4326";
    const UTM33 = "+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs";
    const transformedbboxcenter = proj4(WGS84, UTM33, [mapcenter.lng, mapcenter.lat]);
    return transformedbboxcenter;
}
function mercatorToUTM32(coords, mapcenter) {
    const WEB_MERCATOR = "EPSG:3857";
    const WGS84 = "EPSG:4326";
    const UTM33 = "+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs";
    
    if (!Array.isArray(coords)) {
        throw new Error("Input must be an array of coordinates.");
    }
    
    const mercatorArray = coords.map(coordArray => {          
        return coordArray.map(([x, y]) => {
            const [lon, lat] = proj4(WEB_MERCATOR, WGS84, [x, y]);
            const [xx, yy] = proj4(WGS84, UTM33, [lon, lat]); // Fixed: added comma, removed brackets
            return {xx : xx -  mapcenter[0], yy: yy- mapcenter[1]}; 
        });         
    });
    
    return mercatorArray;
}